import type { ReactNode } from 'react';

export const symbol_exit_to_app: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180h600v-600H180v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-180q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm306-330H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h336l-96-96q-9-9-8.5-22t9.11-22q9.39-9 22.89-9t22.5 9l149 149q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L435-309q-9.33 9-22.17 8.5-12.83-.5-22.22-9.5-8.61-9-8.61-22.5t9-22.5l95-95Z"
		/>
	</svg>
);
